import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

import ScrollToHash from "./components/ScrollToHash";
import Conferencia from "./pages/Conferencia";
import CallForPapers from "./pages/CallForPapers";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/coloquio-internacional-docente">
      <ScrollToHash></ScrollToHash>
      <Header></Header>
      <Routes>
        <Route index element={<Conferencia />} />
        <Route path="/call-for-papers" element={<CallForPapers />} />
      </Routes>

      <Footer></Footer>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
